export enum AppModules {
    mainApp = 'mainApp',
    userManagement = 'userManagement',
}
